/* eslint no-shadow: ["error", { "allow": ["state"] }] */
/* eslint no-param-reassign: ["error", { "props": false }] */
import Vue from 'vue';
import * as mTypes from '../../mutation-types';

const state = {
  zone: {

  },
  coordinates: [],
  error: null,
};

const getters = {
  zone: state => state.zone,
  selectedZoneId: state => (state.zone ? state.zone.id : null),
  error: state => state.error,
  coordinates: state => state.coordinates,
};

const actions = {
  fetch({ commit }, payload) {
    const path = `superadmin/${payload.user.data.id}`;
    return Vue.http.get(`${process.env.BACKEND_API_URL}api/${path}/zones/${payload.id}`)
      .then((response) => {
        commit(mTypes.DATA_FETCHED, response);
      }).catch((response) => {
        commit(mTypes.DATA_ERROR, response);
      });
  },
  saveZone({ commit }, payload) {
    const path = `superadmin/${payload.user.data.id}`;
    let request;

    // Prepare AutoPay data for storing
    payload.zone.autopay_settings = {
      client_secret: payload.zone.client_secret ? payload.zone.client_secret : null,
      client_id: payload.zone.client_id ? payload.zone.client_id : null,
      permit_definition: payload.zone.permit_definition ? payload.zone.permit_definition : null,
    }
    if (
      payload.zone.autopay_settings.client_secret === null &&
      payload.zone.autopay_settings.client_id === null &&
      payload.zone.autopay_settings.permit_definition === null
    ) {
      payload.zone.autopay_settings = null;
    }
    delete payload.zone.client_secret;
    delete payload.zone.client_id;
    delete payload.zone.permit_definition;
    if (payload.zone.id) {
      let payloadData = payload.zone;
      request = Vue.http.put(`${process.env.BACKEND_API_URL}api/${path}/zones/${payload.zone.id}`, payloadData);
    } else {
      request = Vue.http.post(`${process.env.BACKEND_API_URL}api/${path}/zones/`, payload.zone);
    }
    return request
      .then((response) => {
        commit(mTypes.DATA_STORED, response);
      })
      .catch((response) => {
        commit(mTypes.DATA_ERROR, response);
      });
  },
  delete({ commit }, payload) {
    const path = `superadmin/${payload.user.data.id}`;
    return Vue.http.delete(`${process.env.BACKEND_API_URL}api/${path}/zones/${payload.id}`)
      .then(() => { })
      .catch((response) => {
        commit(mTypes.DATA_ERROR, response);
      });
  },
};

const mutations = {
  [mTypes.DATA_FETCHED](state, zone) {
    state.zone = zone.data;
    state.coordinates = state.zone.coordinates;
    state.error = null;
  },
  [mTypes.CLEAR_STATE](state) {
    state.zone = {
      center: [0, 0],
      zoom: 10,
    };
  },
  [mTypes.DATA_STORED](state, zone) {
    state.zone = zone.data;
    state.coordinates = state.zone.coordinates;
    state.error = null;
  },
  [mTypes.DATA_ERROR](state, error) {
    state.error = error;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/zones/zone.js